import { render, staticRenderFns } from "./products-list.vue?vue&type=template&id=2d32a91d&lang=pug&"
import script from "./products-list.vue?vue&type=script&lang=ts&"
export * from "./products-list.vue?vue&type=script&lang=ts&"
import style0 from "./products-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports